// @flow

import StripeShellToggle from './StripeShellToggle';

export default StripeShellToggle;
